export default (theme) => ({
    root: {},
    text: {
        lineHeight: '50px',
        color: theme.colors.primary.white,
    },
});
